import { Client, Account, Databases } from "appwrite";

// Initialize the Appwrite client
const client = new Client()
  .setEndpoint("https://cloud.appwrite.io/v1")
  .setProject("67f171f60033a4819696"); // Your Project ID

export const account = new Account(client);
export const databases = new Databases(client);

// Get current session
export const getCurrentSession = async () => {
  try {
    return await account.getSession("current");
  } catch (error) {
    console.error("Get session error:", error);
    return null;
  }
};

// Get current user
export const getCurrentUser = async () => {
  try {
    return await account.get();
  } catch (error) {
    console.error("Get user error:", error);
    return null;
  }
};

// Authentication functions
export const loginWithEmail = async (email, password) => {
  try {
    const session = await account.createEmailSession(email, password);
    return session;
  } catch (error) {
    console.error("Email login error:", error);
    throw error;
  }
};

export const loginWithGoogle = async (successUrl, failureUrl) => {
  try {
    // Add scopes for Google OAuth
    const scopes = [
      "https://www.googleapis.com/auth/userinfo.email",
      "https://www.googleapis.com/auth/userinfo.profile",
    ];

    return await account.createOAuth2Session(
      "google",
      successUrl,
      failureUrl,
      scopes
    );
  } catch (error) {
    console.error("Google login error:", error);
    throw error;
  }
};

export const signup = async (email, password, name) => {
  try {
    const user = await account.create("unique()", email, password, name);
    if (user) {
      return await loginWithEmail(email, password);
    }
  } catch (error) {
    console.error("Signup error:", error);
    throw error;
  }
};

export const logout = async () => {
  try {
    return await account.deleteSessions();
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};
